module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('navigation-bar', [_c('span', {
    slot: "content"
  }, [_vm._v("个人信息")])]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "weui-cells"
  }, [_c('div', {
    staticClass: "weui-cell"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "weui-cell__ft"
  }, [_vm._v(_vm._s(_vm.user.lastname))])]), _vm._v(" "), _c('div', {
    staticClass: "weui-cell"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "weui-cell__ft"
  }, [_vm._v(_vm._s(_vm.user.firstname))])]), _vm._v(" "), _c('div', {
    staticClass: "weui-cell"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "weui-cell__ft"
  }, [_vm._v(_vm._s(_vm.user.chineseLastname))])]), _vm._v(" "), _c('div', {
    staticClass: "weui-cell"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "weui-cell__ft"
  }, [_vm._v(_vm._s(_vm.user.chinesename))])]), _vm._v(" "), _c('div', {
    staticClass: "weui-cell"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "weui-cell__ft"
  }, [_vm._v(_vm._s(_vm.user.passID))])])]), _vm._v(" "), _c('div', {
    staticClass: "weui-cells"
  }, [_c('div', {
    staticClass: "weui-cell"
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "weui-cell__ft"
  }, [_vm._v(_vm._s(_vm.user.telephone))])]), _vm._v(" "), _c('div', {
    staticClass: "weui-cell"
  }, [_vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "weui-cell__ft"
  }, [_vm._v(_vm._s(_vm.user.email))])])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "weui-cell__bd"
  }, [_c('p', [_vm._v("英文姓")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "weui-cell__bd"
  }, [_c('p', [_vm._v("英文名")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "weui-cell__bd"
  }, [_c('p', [_vm._v("中文姓")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "weui-cell__bd"
  }, [_c('p', [_vm._v("中文名")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "weui-cell__bd"
  }, [_c('p', [_vm._v("护照号")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "weui-cell__bd"
  }, [_c('p', [_vm._v("手机")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "weui-cell__bd"
  }, [_c('p', [_vm._v("邮箱")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-55ffa459!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/Profile.vue
// module id = 193
// module chunks = 2